/**
 * Persistent workspace segment — OAuth return only; chrome lives in authenticated layout.
 */

import { Outlet } from "react-router";

import { TikTokOAuthReturnHandler } from "@/components/workspace/tiktok-oauth-return-handler";

export function WorkspaceShellLayout() {
  return (
    <>
      <TikTokOAuthReturnHandler />
      <Outlet />
    </>
  );
}
